import { getFocusStyle, getTheme, ITheme, mergeStyleSets } from "@fluentui/react";
import * as React from "react";
import { FunctionComponent } from "react";
import { Location } from "@graphql";

const theme: ITheme = getTheme();
const { palette, semanticColors, fonts } = theme;

const classNames = mergeStyleSets({
  itemCell: [
    getFocusStyle(theme, { inset: -1 }),
    {
      minHeight: 54,
      padding: 10,
      boxSizing: "border-box",
      borderBottom: `1px solid ${semanticColors.bodyDivider}`,
      display: "flex",
      selectors: {
        "&:hover": { background: palette.neutralLight },
      },
    },
  ],
  itemContent: {
    marginLeft: 10,
    overflow: "hidden",
    flexGrow: 1,
  },
  itemName: [
    fonts.mediumPlus,
    {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      flex: 3,
    },
  ],
  address: {
    fontSize: fonts.small.fontSize,
    color: palette.neutralTertiary,
    marginBottom: 10,
    marginTop: 10,
  },
  chipContainer: {
    flex: 1,
    textAlign: "right",
  },
  activeChip: {
    fontSize: fonts.small.fontSize,
    marginTop: 10,
    borderRadius: 5,
    backgroundColor: "purple",
    padding: 5,
    color: "white",
  },
});

interface Props {
  location: Location;
  index: number;
  isActive?: boolean;
  onLocationClick: (id: string) => void;
}

const LocationCard: FunctionComponent<Props> = (props: Props) => {
  const { location, onLocationClick, isActive } = props;

  const onSelect = () => {
    onLocationClick(location._id);
  };

  return (
    <div className={classNames.itemCell} data-is-focusable={true} onClick={onSelect}>
      <div className={classNames.itemContent}>
        <div style={{ display: "flex", marginTop: 6 }}>
          <div className={classNames.itemName}>{location.name}</div>
          <div className={classNames.chipContainer}>
            {isActive && <span className={classNames.activeChip}>Active</span>}
          </div>
        </div>
        {location.address && location.address.formattedAddress && (
          <div className={classNames.address}>{location.address.formattedAddress}</div>
        )}
      </div>
    </div>
  );
};

export default LocationCard;
